import { useQueryClient } from "@tanstack/react-query";

import {
    getGetTestingProgramsQueryKey,
    getGetTestingProgramsTestingProgramIdQueryKey,
    useDeleteTestingProgramsTestingProgramId,
} from "api/generated/testing-programs/testing-programs";

export const useDeleteTestingProgramMutation = () => {
    const client = useQueryClient();
    return useDeleteTestingProgramsTestingProgramId({
        mutation: {
            onSuccess: (_data, { testingProgramId }) => {
                client.invalidateQueries({
                    queryKey: getGetTestingProgramsQueryKey(),
                });
                client.invalidateQueries({
                    queryKey:
                        getGetTestingProgramsTestingProgramIdQueryKey(
                            testingProgramId
                        ),
                });
            },
        },
    });
};
